export default __webpack_public_path__ + "static/customer1-03758e766c4dba303e8f529c3db7b64a.png";